module.exports = __webpack_public_path__ + "static/media/banner-mobile.3128acd9.webp";